<script setup>

import StraylightSlider from "./StraylightSlider.vue";
import {ref, useTemplateRef} from "vue";
import {onKeyStroke, useScrollLock} from "@vueuse/core";

const { pictures, options } = defineProps({
    pictures: { type: Object, default: {} },
    options: { type: Object, default: {} },
});

const showModal = ref(false);
const sliderEl = useTemplateRef('sliderEl');
const isLocked = useScrollLock( document.body )

function openModal(index) {
    sliderEl.value.goToSlide( parseInt( index ) );
    showModal.value = true;
    isLocked.value = true;
}

onKeyStroke('Escape', (e) => {
    if ( showModal.value ) {
        e.preventDefault();
        showModal.value = false;
        isLocked.value = false;
    }
});
</script>

<template>
    <straylight-slider class="overflow-hidden" :autoplay="options.autoplay" :interval="options.interval" :options="options">
        <div class="slider-item | relative" v-for="(picture, index) in pictures" :key="index">
            <img :src="picture.sizes.medium_large" alt="" @click="openModal( index )">
        </div>
    </straylight-slider>

    <teleport to="body">
        <transition>
            <div class="fixed inset-0 px-5 bg-black/60 z-[100]" v-show="showModal">
                <straylight-slider ref="sliderEl" class="h-full" :options="{
                    wrapperClass: 'h-full',
                    itemsPerView: 1,
                    gapRem: 0.5,
                    arrows: false,
                }">
                    <div class="slider-item | relative w-full" v-for="(picture, index) in pictures" :key="index">
                        <div class="w-10/12 lg:w-6/12 xl:w-5/12 h-full mx-auto flex flex-col justify-center">
                            <img :src="picture.url" alt="" class="w-auto h-auto">
                        </div>
                    </div>
                </straylight-slider>

                <button @click="sliderEl.previous()"
                        class="absolute top-1/2 left-10 -translate-y-1/2
                            border border-transparent text-darkblue bg-white hover:border-copper transition-colors rounded-full h-12 w-12 flex flex-col justify-center place-items-center
                        disabled:opacity-50 disabled:pointer-events-none"
                        type="button">
                    <i class="fa-solid fa-chevron-left"></i>
                </button>

                <button @click="sliderEl.next()"
                        class="absolute top-1/2 right-10 -translate-y-1/2
                            border border-transparent text-darkblue bg-white hover:border-copper transition-colors rounded-full h-12 w-12 flex flex-col justify-center place-items-center
                        disabled:opacity-50 disabled:pointer-events-none"
                        type="button">
                    <i class="fa-solid fa-chevron-right"></i>
                </button>

                <button @click="showModal = false; isLocked = false"
                        class="absolute top-10 right-10 -translate-y-1/2
                            text-white bg-transparent border border-transparent  hover:text-darkblue hover:bg-white hover:border-copper text-2xl p-2 transition-colors rounded-full h-12 w-12 flex flex-col justify-center place-items-center"
                        type="button">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </transition>
    </teleport>
</template>